const { Button } = require('@material-tailwind/react')
const { FiDownload } = require('react-icons/fi')

export const DownloadButton = () => {
  return (
    <Button variant='outlined' className='flex items-center gap-3' color='white'>
      <FiDownload size='1rem' />
      Descargar
    </Button>
  )
}
